import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AskSimpoChat {
  id: string;
  title: string;
  project_id: string | null;
  starred: boolean;
  message_count: number;
  created_at: string;
  updated_at: string;
}

export interface AskSimpoChatListResponse {
  chats: AskSimpoChat[];
  chat_page: { has_more: boolean; before: string | null };
}

@Injectable({ providedIn: 'root' })
export class AskSimpoChatService {
  private readonly base = environment.askSimpoApiUrl;

  constructor(private http: HttpClient) {}

  private ctxHeaders(): HttpHeaders {
    return new HttpHeaders({
      accept: 'application/json',
      'X-Business-Id': localStorage.getItem('businessId') || '',
      'X-Staff-Id': localStorage.getItem('staffId') || '',
    });
  }

  getChats(): Observable<AskSimpoChatListResponse> {
    return this.http.get<AskSimpoChatListResponse>(`${this.base}/chats`, {
      headers: this.ctxHeaders(),
    });
  }

  deleteChat(chatId: string): Observable<unknown> {
    return this.http.delete(`${this.base}/chats/${chatId}`, {
      headers: new HttpHeaders({ accept: 'application/json' }),
    });
  }
}
